import React, { useContext } from 'react';
import { Col, Form, FormGroup, Label, Row } from 'reactstrap';
import UploaderContainer from '../../../../../components/Uploader/UploaderContainer';
import { toTitleCase } from '../../../../../utils/string-utils';
import { FormikValues, useFormikContext } from 'formik';
import { FormProps } from '../../../../WorkflowContainer/workflow-utils';
import { EmailType } from '../../../../../utils/email-utils';
import { UserContext, UserContextProps } from '../../../../../App';
import { EmailPreviewModalv3 } from '../../../../../components/EmailPreviewModal/EmailPreviewModalv3';
import { convertToFlowableVariables } from '../../../../../utils/flowable/flowable-utils';

export const InitialHearingExternalRepresentationSubmissionsForm: React.FC<FormProps> = props => {
  const { values } = useFormikContext<FormikValues>();
  const currentUser = useContext<Partial<UserContextProps>>(UserContext).currentUser;

  const getRecipients = () => {
    return [
      {
        emailAddress: props.data.caseData.initial_hearing_chairpersonEmailAddress,
        name: toTitleCase(props.data.caseData.initial_hearing_chairpersonFirstName, ' '),
      },
    ];
  };

  return (
    <Form>
      <Row>
        <Col md={3}>
          <FormGroup>
            <Label for="exampleFile" className="text-default text-capitalize">
              Upload Employee submission
            </Label>
            <UploaderContainer
              fieldName={'initial_hearing_externalRepresentationApplicationEmployeeSubmissionDocuments'}
              path={`cases/${props.data.masterProcessInstanceId}`}
            />
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col md={3}>
          <FormGroup>
            <Label for="exampleFile" className="text-default text-capitalize">
              Upload Employer Response
            </Label>
            <UploaderContainer
              fieldName={'initial_hearing_externalRepresentationApplicationEmployerResponseDocuments'}
              path={`cases/${props.data.masterProcessInstanceId}`}
            />
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col>
          <EmailPreviewModalv3
            emailType={EmailType.NOTIFY_CHAIRPERSON_OF_SUBMISSIONS_FOR_EXTERNAL_REPRESENTATION}
            processInstanceId={props.data.processInstanceId}
            masterProcessInstanceId={props.data.masterProcessInstanceId}
            currentUserId={currentUser?.id}
            getRecipients={getRecipients}
            buttonText={'Send Email to Chairperson'}
            formValues={values}
            disabled={
              !values.initial_hearing_externalRepresentationApplicationEmployeeSubmissionDocuments &&
              !values.initial_hearing_externalRepresentationApplicationEmployerResponseDocuments
            }
            getFlowableVariables={() => convertToFlowableVariables(props.getFormValuesForSubmission(values))}
          />
        </Col>
      </Row>
    </Form>
  );
};
